/* eslint import/no-extraneous-dependencies: 0 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createApp } from 'vue';
import store from '@/store';
import api from '@/store/api';
import i18n from '@/store/i18n';
import clickOutside from '@/utils/click_outside';
import cookie from '@/utils/cookie';
import { installUmamiHashPageviews } from '@/utils/umami_hash_pageviews';
import { moment, localeDate, datePickerLang } from '@/store/i18n/dates';
import 'vue-loading-overlay/dist/css/index.css';
import 'vue-multiselect/dist/vue-multiselect.css';
import '@vueform/slider/themes/default.css';
import '@fullcalendar/vue3/skeleton.css';
import '@fullcalendar/vue3/themes/classic/theme.css';
import '@fullcalendar/vue3/themes/classic/palette.css';
import 'vue-datepicker-next/index.css';

window._ = require('lodash');

// tab moves (URL hash) become Umami pageviews; one listener per page however many packs are loaded
installUmamiHashPageviews();

/**
 * Root application for a page (or for one tab of a page): the shared vuex store and i18n plus the
 * globals components expect — `this.$store`, `this.$http`, `this.$cookie`, `this.moment`, `this.locale`,
 * `this.localeDate`, `this.datePickerLang` — and the `v-click-outside` directive.
 *
 * A pack either mounts it right away (`createHpApp({ components }).mount('#some-app')`) or leaves it
 * on `window` for the legacy CoffeeScript to mount when its tab is first opened.
 */
export function createHpApp(options = {}) {
  const app = createApp(options);

  app.use(store);
  app.use(i18n);
  app.directive('click-outside', clickOutside);

  Object.assign(app.config.globalProperties, {
    $http: api,
    $cookie: cookie,
    moment,
    locale: i18n.global.locale,
    localeDate,
    datePickerLang: datePickerLang(),
  });

  return app;
}

export { i18n, store, api, moment, localeDate };
